// extracted by mini-css-extract-plugin
module.exports = {"cell":"Cell_cell__2FLTY","static":"Cell_static__PlRFV","variable":"Cell_variable__3CNTD"};